import React from 'react';
import { NumericFormat } from 'react-number-format';

export function BRLCurrencyFormat(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      thousandSeparator={'.'}
      decimalSeparator={','}
      prefix={'R$ '}
      isNumericString
    />
  );
}